import * as _ from 'lodash';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import * as sessionUtils from 'login-utils/sessionUtils';
import * as stateUtils from 'login-utils/stateUtils';
import * as queryString from 'query-string';
import TermsOfServicePixelTracker from './TermsOfServicePixelTracker';
import TermsOfService from './TermsOfService';

interface OwnState {
  isSubmitting: boolean;
  queryParams: {
    loanType?: string;
    displayLink?: string;
    referrerId?: string;
    app_source?: string;
    applicationTemplateId?: string;
  };
}

class LoanEstimateTermsOfService extends React.Component<RouteComponentProps<{}, {}>, OwnState> {
  constructor(props) {
    super(props);
    const query = queryString.parse(props.location.search);

    const queryParams = stateUtils.getOptionalCreationParams(query, [
      'referrerId',
      'app_source',
      'applicationTemplateId',
      'displayLink',
      'loanType',
    ]);

    this.state = {
      queryParams,
      isSubmitting: false,
    };
  }

  componentDidMount() {
    const { location } = this.props;
    const query = queryString.parse(location.search);
    // react-router puts the query string after the hash, so it's not sent to the server
    sessionUtils.saveQueryToSession(query);
  }

  render() {
    return (
      <div>
        <TermsOfService
          onSubmit={_.noop}
          isSubmitting={this.state.isSubmitting}
          action="/api/public/anonymous-borrowers"
          queryParams={this.state.queryParams}
        />
        <TermsOfServicePixelTracker />
      </div>
    );
  }
}

export default LoanEstimateTermsOfService;
